import React, { useState, useEffect, useCallback } from 'react';
import AdminMarketRequests from './AdminMarketRequests';

// Урезанная панель "Маркетплейс", доступная из бокового меню.
// Показывает только заявки на склад и заказы — без Общего и Рекламы.
// Использует тот же AdminMarketRequests, что и полная Админ-панель
// (Маркетплейс → Заявки на склад/Заказы), поэтому логика и данные полностью совпадают.
function MarketPanel({ tgId, adminNickname, canAct }) {
  const [subTab, setSubTab] = useState('requests'); // requests, orders
  // Количество активных заявок по каждой подвкладке — тот же источник
  // данных, что и бейдж у пункта "Маркетплейс" в боковом меню, только
  // с разбивкой по типу.
  const [counts, setCounts] = useState({ requests: 0, orders: 0 });

  const fetchCounts = useCallback(async () => {
    try {
      const res = await fetch('/api/market/admin-pending-count');
      const data = await res.json();
      setCounts({ requests: data.requests || 0, orders: data.orders || 0 });
    } catch (err) {
      console.error('Ошибка загрузки количества заявок маркетплейса', err);
    }
  }, []);

  useEffect(() => {
    fetchCounts();
    const interval = setInterval(fetchCounts, 2000);
    return () => clearInterval(interval);
  }, [fetchCounts]);

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Маркетплейс</h2>

      <div className="sub-tabs">
        <button className={subTab === 'requests' ? 'active' : ''} onClick={() => setSubTab('requests')}>
          Заявки на склад
          {counts.requests > 0 && <span className="sub-tab-badge">{counts.requests > 99 ? '99+' : counts.requests}</span>}
        </button>
        <button className={subTab === 'orders' ? 'active' : ''} onClick={() => setSubTab('orders')}>
          Заказы
          {counts.orders > 0 && <span className="sub-tab-badge">{counts.orders > 99 ? '99+' : counts.orders}</span>}
        </button>
      </div>

      <AdminMarketRequests tgId={tgId} adminNickname={adminNickname} activeSubTab={subTab} canAct={canAct} />
    </div>
  );
}

export default MarketPanel;
